import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import DropDown from 'components/forms/new/formikFormFields/DropDown';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import walkthroughIds from '../../../walkthroughIds';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';

const OperatorConnectAuthPolicyField = ({
    field,
    form,
    options,
    darkMode,
    onChange,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const error =
        form.errors.authPolicy && form.touched.authPolicy
            ? form.errors.authPolicy
            : '';
    const authPolicyData = (options || []).map((opt) => ({
        ...opt,
        id: opt.value,
        name: opt.label,
    }));
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!error}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Auth Policy <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Select the authentication policy for this service.
                    </Text>
                </Box>
                <Box flex="1" minWidth="450px">
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            alignItems: 'flex-start',
                            paddingTop: '15px',
                        }}>
                        <VStack width="100%" alignItems="normal">
                            <DropDown
                                field={field}
                                name="authPolicy"
                                data={authPolicyData}
                                shownValue="name"
                                alphabetical={false}
                                noPadding
                                placeholder="Select Auth Policy"
                                walkthroughId={
                                    walkthroughIds.serviceProfiles
                                        ?.ufAuthPolicySelect
                                }
                                darkMode={darkMode}
                                width="100%"
                                handleSelectChange={(item) => {
                                    const newValue = item?.id ?? null;
                                    form.setFieldValue('authPolicy', newValue);
                                    onChange && onChange(newValue);
                                }}
                            />

                            <Text
                                color="red.500"
                                fontSize="xs"
                                mt={1}
                                textAlign="right">
                                {error}
                            </Text>
                        </VStack>
                    </Box>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select the authentication policy for this service."
                        ariaLabel="operator-connect-auth-policy-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default OperatorConnectAuthPolicyField;
